import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LTileLayer = _resolveComponent("LTileLayer")
  const _component_LControlAttribution = _resolveComponent("LControlAttribution")
  const _component_LTooltip = _resolveComponent("LTooltip")
  const _component_LMarker = _resolveComponent("LMarker")
  const _component_LMap = _resolveComponent("LMap")

  return (_openBlock(), _createElementBlock("a", {
    href: $options.mapLink,
    target: "_blank",
    rel: "noopener noreferrer",
    class: _normalizeClass(["location", { wide: $props.wide }]),
    "aria-label": $options.linkAriaLabel
  }, [
    _createVNode(_component_LMap, {
      zoom: $data.previewZoom,
      center: $options.center,
      options: {
				scrollWheelZoom: false,
				zoomControl: false,
				dragging: false,
				attributionControl: false,
			},
      onScroll: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LTileLayer, { url: $data.url }, null, 8, ["url"]),
        _createVNode(_component_LControlAttribution, {
          position: "bottomright",
          prefix: $data.attribution
        }, null, 8, ["prefix"]),
        _createVNode(_component_LMarker, { "lat-lng": $options.center }, {
          default: _withCtx(() => [
            _createVNode(_component_LTooltip, { options: {
						direction: 'top',
						permanent: 'true',
						offset: [-16, -14],
					} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["lat-lng"])
      ]),
      _: 1
    }, 8, ["zoom", "center"])
  ], 10, _hoisted_1))
}